import { Amplify } from 'aws-amplify';
import { isAdminPortal } from 'utils';
// Debug Auth
// window.LOG_LEVEL = 'DEBUG';

const awsDomain = import.meta.env.VITE_AWS_DOMAIN;
const awsRegion = import.meta.env.VITE_AWS_REGION;
const awsUserPoolId = import.meta.env.VITE_AWS_USER_POOL_ID;
const awsClientId = import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID;
const awsFlowTypeAdmin = import.meta.env.VITE_AWS_FLOW_TYPE_ADMIN || 'USER_SRP_AUTH';
const awsFlowTypeClient = import.meta.env.VITE_AWS_FLOW_TYPE_CLIENT || 'USER_SRP_AUTH';
const awsFlowType = isAdminPortal ? awsFlowTypeAdmin : awsFlowTypeClient;


// Cognito Hosted UI configuration
const config = {
    Auth: {
        Cognito: {
            userPoolId: awsUserPoolId,
            userPoolClientId: awsClientId,
            loginWith: {
                oauth: {
                    domain: `${awsDomain}.auth.${awsRegion}.amazoncognito.com`,
                    scopes: [
                        'phone',
                        'email',
                        'openid',
                        'profile',
                        'aws.cognito.signin.user.admin',
                    ],
                    redirectSignIn: [`${window.location.origin}/token`],
                    redirectSignOut: [`${window.location.origin}/token`],
                    responseType: 'code',
                },
            },
            signUpVerificationMethod: 'code',
        },
    },
};

Amplify.configure(config);

// Expose authenticationFlowType for components that need it
export const authenticationFlowType = awsFlowType;

export default config;
